import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import style from './ProductLineCard.module.sass'

type ProductLineCardProps = {
	name?: string
	url: string
	imageUrl?: string
	isDisabled?: boolean
}

export const ProductLineCard: FunctionComponent<ProductLineCardProps> = ({
	name,
	url,
	imageUrl,
	isDisabled = false,
}) => {
	const translate = useTranslate()
	const content = (
		<>
			<div className={style.image}>
				{imageUrl && (
					<NextImage
						src={imageUrl}
						alt={translate('alternativeText.productLine')}
						title={`${name} - logo`}
						layout="fill"
						objectFit="contain"
					/>
				)}
			</div>
			<div className={style.title}>{name}</div>
		</>
	)

	if (isDisabled) {
		return <div className={clsx(style.root, style.rootDisabled)}>{content}</div>
	}
	return (
		<Link href={url} className={clsx(style.root, style.rootLink)} title={name}>
			{content}
		</Link>
	)
}
